import React from 'react';
import styled from 'styled-components';
import { Avatar, MemberContactPopover, Tooltip } from '~/components';
import { colors } from '~/styles';

const Stack = styled.div`
  display: flex;
  align-items: center;
  /* The overlap below is ordered with z-index; contain it here so it can't outrank a sticky column and ride
     over it when the list scrolls sideways. */
  isolation: isolate;
`;

const Item = styled.div`
  position: relative;
  z-index: ${({ $z }) => $z};

  &:not(:first-child) {
    margin-left: -0.35rem;
  }

  figure {
    box-shadow: 0 0 0 2px ${colors.white};
  }
`;

const Overflow = styled.div`
  position: relative;
  margin-left: -0.35rem;
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  color: ${colors.grey40};
  background-color: ${colors.grey5};
  box-shadow: 0 0 0 2px ${colors.white};
`;

export default function AvatarStack({ members, max = 5, size = '1.75rem' }) {
  if (!members?.length) return null;

  const visible = members.length > max ? members.slice(0, max) : members;
  const overflow = members.length > max ? members.slice(max) : [];

  return (
    <Stack>
      {visible.map((member, index) => (
        <Item key={member.id ?? index} $z={members.length - index}>
          <MemberContactPopover member={member} placement="left">
            <Avatar value={member} isCircle hasBackground size={size} initialsFontSize="0.7rem" />
          </MemberContactPopover>
        </Item>
      ))}

      {overflow.length > 0 && (
        <Tooltip maxWidth="20rem" message={overflow.map((member) => member.name).join(', ')}>
          <Overflow $size={size}>+{overflow.length}</Overflow>
        </Tooltip>
      )}
    </Stack>
  );
}
